import React from 'react';

const Product2 = () => {
  
};

export default Product2;
